import { render, staticRenderFns } from "./NurseProfileEdit.vue?vue&type=template&id=72656ba4&"
import script from "./NurseProfileEdit.vue?vue&type=script&lang=js&"
export * from "./NurseProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./NurseProfileEdit.vue?vue&type=style&index=0&id=72656ba4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports